export default "__VITE_PUBLIC_ASSET__05d47c2e__"